import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaServer, FaLevelUpAlt, FaCube, FaCoins, FaRobot, FaClock, FaGamepad, FaVrCardboard, FaWallet } from 'react-icons/fa';
import { GiGalaxy, GiMinerals, GiCyberEye } from "react-icons/gi";
import { BiCube } from "react-icons/bi";
import './Games.scss';
import mascotImage from '../../../assets/reddickrednobackground.png';
import gamePreviewImage from '../../../assets/reddickofficeexample.png';
import featureIconRadix from '../../../assets/radix-icon.svg';
import Header from '../Header';
import Footer from '../Footer';
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup';

// Countdown Timer Component
const CountdownTimer = ({ targetDate, onCountdownOver }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        if (onCountdownOver) {
          onCountdownOver();
        }
      }
    };

    // Initial check
    calculateTimeLeft();
    
    const timer = setInterval(calculateTimeLeft, 1000);

    // Cleanup
    return () => clearInterval(timer);
  }, [targetDate, onCountdownOver]);

  return (
    <div className="countdown-timer">
      <div className="countdown-header">
        <FaClock className="countdown-icon" />
        <span className="countdown-label">Full Launch Countdown</span>
      </div>
      <div className="countdown-display">
        <div className="time-unit">
          <div className="time-number">{timeLeft.days.toString().padStart(2, '0')}</div>
          <div className="time-label">Days</div>
        </div>
        <div className="time-separator">:</div>
        <div className="time-unit">
          <div className="time-number">{timeLeft.hours.toString().padStart(2, '0')}</div>
          <div className="time-label">Hours</div>
        </div>
        <div className="time-separator">:</div>
        <div className="time-unit">
          <div className="time-number">{timeLeft.minutes.toString().padStart(2, '0')}</div>
          <div className="time-label">Minutes</div>
        </div>
        <div className="time-separator">:</div>
        <div className="time-unit">
          <div className="time-number">{timeLeft.seconds.toString().padStart(2, '0')}</div>
          <div className="time-label">Seconds</div>
        </div>
      </div>
    </div>
  );
};

const Games = () => {
  const navigate = useNavigate();
  const targetDate = "2025-06-27T18:00:00+02:00";
  const [isCountdownOver, setIsCountdownOver] = useState(() => new Date() > new Date(targetDate));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCountdownOver = () => {
    setIsCountdownOver(true);
  };

  const handleRedirect = () => {
    navigate('/start');
  };

  return (
    <div className="home-page games-page">
      <Header />

      <main className="home-content">
        <section className="hero-section">
          <div className="hero-content">
            <h1>REDDICKS <span className="p2e-tag">P2E</span></h1>
            
            {/* Countdown Timer */}
            <CountdownTimer targetDate={targetDate} onCountdownOver={handleCountdownOver} />
            
            <div className="hero-text">
              <p className="subtitle">Step Into Your 3D Cyberpunk Office & Build Your Mining Empire</p>
              <button 
                className={`cta-button ${!isCountdownOver ? 'coming-soon-button' : ''}`}
                disabled={!isCountdownOver}
                onClick={isCountdownOver ? handleRedirect : undefined}
              >
                {isCountdownOver ? 'Enter Early Access' : 'Early Access Coming Soon'}
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img src={mascotImage} alt="Reddicks Mascot - Ready to Play!" />
            <div className="floating-particles">
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
            </div>
          </div>
        </section>

        <section className="game-preview-section">
          <div className="container">
            <h2>Your Cyberpunk Office Awaits</h2>
            <div className="game-preview-content">
              <div className="preview-image-container">
                <img src={gamePreviewImage} alt="Reddicks 3D Cyberpunk Office" className="game-preview-image" />
                <div className="preview-overlay">
                  <div className="play-indicator">
                    <FaGamepad className="play-icon" />
                    <span>Interactive 3D Environment</span>
                  </div>
                </div>
              </div>
              <div className="preview-info">
                <h3>Immersive Browser-Based Gaming</h3>
                <p>Enter a fully realized <strong>3D cyberpunk office space</strong> that runs directly in your browser using WebGL technology. No downloads, no installations—just pure gaming experience.</p>
                
                <div className="feature-highlight">
                  <GiCyberEye className="feature-icon" />
                  <div className="feature-content">
                    <h4>Real-Time 3D Environment</h4>
                    <p>Navigate your cyberpunk office with WASD controls, complete with atmospheric lighting, interactive objects, and immersive sound design.</p>
                  </div>
                </div>

                <div className="feature-highlight">
                  <BiCube className="feature-icon" />
                  <div className="feature-content">
                    <h4>Mining Rig Management</h4>
                    <p>Place and manage up to 4 different tiers of mining rigs in your office space. Watch them generate passive $REDDICKS income in real-time.</p>
                  </div>
                </div>

                <div className="feature-highlight">
                  <FaWallet className="feature-icon" />
                  <div className="feature-content">
                    <h4>Direct Wallet Integration</h4>
                    <p>Experience true ownership. Your in-game assets and $REDDICKS are directly linked to your Radix wallet for maximum security and control.</p>
                  </div>
                </div>

                <button 
                  className={`preview-button ${!isCountdownOver ? 'coming-soon-button' : ''}`}
                  disabled={!isCountdownOver}
                  onClick={isCountdownOver ? handleRedirect : undefined}
                >
                  {isCountdownOver ? 'Experience the Office' : 'Experience the Office'}
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="gameplay-mechanics-section">
          <div className="container">
            <h2>Core Gameplay Mechanics</h2>
            <div className="mechanics-grid">
              <div className="mechanic-card mining">
                <div className="card-header">
                  <GiMinerals className="mechanic-icon" />
                  <h3>Mining Operations</h3>
                </div>
                <div className="card-content">
                  <div className="mechanic-detail">
                    <strong>4 Rig Tiers:</strong> From basic (10 power) to advanced (40 power) mining rigs
                  </div>
                  <div className="mechanic-detail">
                    <strong>Passive Income:</strong> Earn up to 50 $REDDICKS per hour based on your setup
                  </div>
                  <div className="mechanic-detail">
                    <strong>Efficiency Multipliers:</strong> Higher tiers provide better efficiency (1x to 2x)
                  </div>
                </div>
              </div>

              <div className="mechanic-card economics">
                <div className="card-header">
                  <FaCoins className="mechanic-icon" />
                  <h3>Token Economics</h3>
                </div>
                <div className="card-content">
                  <div className="mechanic-detail">
                    <strong>Daily Pool:</strong> 2,000 $REDDICKS distributed across all miners daily
                  </div>
                  <div className="mechanic-detail">
                    <strong>Offline Income:</strong> Earn up to 7 days of passive income while away
                  </div>
                  <div className="mechanic-detail">
                    <strong>Fair Distribution:</strong> Rewards based on your mining power contribution
                  </div>
                  <div className="mechanic-detail">
                    <strong>Mining Requirement:</strong> Minimum 15,000 $REDDICKS in wallet to earn rewards
                  </div>
                </div>
              </div>

              <div className="mechanic-card progression">
                <div className="card-header">
                  <FaLevelUpAlt className="mechanic-icon" />
                  <h3>Progression System</h3>
                </div>
                <div className="card-content">
                  <div className="mechanic-detail">
                    <strong>Start with 500:</strong> Begin your journey with starting capital
                  </div>
                  <div className="mechanic-detail">
                    <strong>Upgrade Path:</strong> Reinvest earnings into powerful rigs (costs: 500, 1000, 2000, 4000 $REDDICKS)
                  </div>
                  <div className="mechanic-detail">
                    <strong>Leaderboards:</strong> Compete with other miners for top earnings
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="why-reddicks-section">
          <div className="container">
            <h2>Why Choose Reddicks P2E?</h2>
            <div className="why-grid">
              <div className="why-card earn-card">
                <FaCoins className="why-icon why-earn" />
                <h3>Real Token Rewards</h3>
                <p>Earn actual $REDDICKS tokens that can be withdrawn to your Radix wallet. Your gaming skill translates to real value.</p>
              </div>
              <div className="why-card tech-card">
                <GiGalaxy className="why-icon why-tech" />
                <h3>Cutting-Edge Tech</h3>
                <p>Built with Three.js and WebGL for smooth 3D performance. Experience console-quality graphics in your browser.</p>
              </div>
              <div className="why-card community-card">
                <FaRobot className="why-icon why-community" />
                <h3>Vibrant Community</h3>
                <p>Join a thriving ecosystem of miners, traders, and cyberpunk enthusiasts building the future of Web3 gaming.</p>
              </div>
              <div className="why-card radix-card">
                <img src={featureIconRadix} alt="Radix Network Icon" className="why-icon why-radix-img" />
                <h3>Powered by Radix</h3>
                <p>Built on the most advanced DeFi platform with instant transactions and enterprise-grade security.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="join-mayhem-section">
          <div className="container">
            <h2>Ready to Build Your Empire?</h2>
            <p>Step into the future of Play-to-Earn gaming with Reddicks. Build your mining operation, earn real tokens, and become part of the cyberpunk revolution!</p>
            <div className="mayhem-cta">
              <button 
                className={`cta-button mayhem-button ${!isCountdownOver ? 'coming-soon-button' : ''}`}
                disabled={!isCountdownOver}
                onClick={isCountdownOver ? handleRedirect : undefined}
              >
                Launch Your Career
              </button>
            </div>
            <div className="mascot-flyby">
              <img src={mascotImage} alt="Reddicks flying by"/>
            </div>
          </div>
        </section>

      </main>

      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default Games; 